export default {
	invalidProps: '最小时间不能大于最大时间',
	invalidTime: '无效的时间格式',
	tooEarly: '所选时间不能小于最小时间',
	tooLate: '所选时间不能大于最大时间'
};
